import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import countryList from '../../../utils/consts/countryList.json';
import './telephoneInput.scss';
import { SearchIcon, CloseIcon } from '../../../content/svg-component';
import { fileHandlerUrl } from '../../../utils/consts/server';

const scrollBar = createRef();
const outSideClick = createRef(null);
class TelephoneInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: '',
      list: countryList,
      inputValue: props.telephoneNumber.includes('+')
        ? props.telephoneNumber.slice(1)
        : props.telephoneNumber,
      isOpen: false,
      selectIndex: 0,
      currentCountry: this.findCountry(props.activeCountry, props.countryAbr),
      maxlength: props.telephoneNumber
        ? (props.activeCountry + props.telephoneNumber).length
        : 12,
      error: false,
    };
  }
  componentDidMount() {
    let { activeCountry, countryAbr } = this.props;
    let country = this.findCountry(activeCountry, countryAbr);
    this.setState({
      currentCountry: country,
      inputValue: this.props.telephoneNumber || country.phoneCode,
    });
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    let { currentCountry } = this.state,
      { activeCountry, countryAbr, telephoneNumber } = nextProps;
    if (
      currentCountry.countryCode?.toLowerCase() !== countryAbr?.toLowerCase()
    ) {
      let country = this.findCountry(activeCountry, countryAbr);
      if (country && Object.entries(country)?.length)
        this.setState({
          currentCountry: country,
          maxlength: country.phoneFormat.split('.').length - 1,
          inputValue: country.phoneCode,
        });
    }
    if (
      telephoneNumber?.length &&
      telephoneNumber !== this.props.telephoneNumber
    ) {
      let country = this.findCountry(activeCountry, countryAbr);

      this.setState({
        currentCountry: country,
        inputValue: this.formatMobilevalue(
          telephoneNumber.substring(1),
          currentCountry,
        ),
        country,
      });
    }
  }
  findCountry = (code = 0, countryAbr = '') => {
    return (
      countryList.filter(
        (item) =>
          item?.phoneCode === code ||
          item?.countryCode.toLowerCase() === countryAbr?.toLowerCase(),
      )?.[0] || countryList[105]
    );
  };
  handleClickOutside = (event) => {
    if (outSideClick.current && !outSideClick.current.contains(event.target)) {
      this.cleanState();
    }
  };
  findCountryByCode = (cleanValue) => {
    let findCountryCounter = 4;
    let country = [];
    while (findCountryCounter > 0) {
      country = countryList.filter(
        (i) => i.phoneCode === cleanValue.slice(0, findCountryCounter).join(''),
      );
      if (country.length) return country;
      else findCountryCounter -= 1;
    }
    return country;
  };

  inputOnChange = (value) => {
    value = value.replace(/[^\d]/g, '');
    let { currentCountry, maxlength } = this.state;
    if (!value) {
      this.setState({ inputValue: '' }, () => {
        this.props.onChange({
          code: '98',
          country: currentCountry.countryCode,
          number: '',
          fullNumber: '',
        });
      });
    } else {
      let cleanValue = value
        .replaceAll(' ', '')
        .split('')
        .filter((i) => Number(i) || '-');

      let country = [];
      if (cleanValue.length === 4) {
        country = this.findCountryByCode(cleanValue)[0];
      } else {
        country = { ...currentCountry };
      }
      if (cleanValue.length <= country?.phoneFormat.split('.').length - 1) {
        let phoneNumber = '',
          current = 0;
        cleanValue.map((val, index) => {
          country.phoneFormat[index + current] === '.'
            ? (phoneNumber += val)
            : ((phoneNumber += ' ' + val), (current = current + 1));
        });
        phoneNumber = this.formatMobilevalue(phoneNumber, country);
        this.setState(
          {
            inputValue: phoneNumber,
            currentCountry: country,
            maxlength: country.phoneFormat.split('.').length - 1,
            isOpen: false,
          },
          () => {
            cleanValue.length == maxlength &&
              this.props.onChange({
                code: country?.phoneCode,
                country: country?.countryCode,
                number: phoneNumber.replace(`${country?.phoneCode} `, ''),
                fullNumber: `+${phoneNumber}`,
              });
          },
        );
      }
    }
  };
  formatMobilevalue = (fullNumber, currentCountry) => {
    fullNumber = fullNumber.replaceAll(' ', '');
    let phoneNumber = '',
      current = 0;
    fullNumber.split('').map((val, index) => {
      currentCountry.phoneFormat[index + current] === '.'
        ? (phoneNumber += val)
        : ((phoneNumber += ' ' + val), (current = current + 1));
    });
    return phoneNumber;
  };

  searchCountry = ({ value }) => {
    if (value.length <= 4) {
      let country = countryList.filter(
        (item) =>
          item?.name?.en.toLowerCase().includes(value.toLowerCase()) ||
          item?.phoneCode?.startsWith(value) ||
          item?.countryCode?.includes(value),
      );

      this.setState({
        searchValue: value,
        list: country.length ? country : countryList,
      });
    }
  };
  //use callbak for clean some state
  cleanState = () => {
    this.setState({ isOpen: false, searchValue: '' }, () => {
      () => {
        document.addEventListener('mousedown', this.handleClickOutside);
      };
    });
    scrollBar.current.scrollTop = 0;
  };
  renderList = (list = [], selectIndex) => {
    return list.map((item, index) => {
      return (
        <div
          className={`${
            selectIndex == index && 'bg-gray'
          } rounded d-flex align-items-center px-3 cursor-pointer dropdown-list-item-height`}
          key={`countryDropDown${index}`}
          onClick={() => {
            this.setState(
              {
                isOpen: false,
                currentCountry: item,
                selectIndex: index,
                inputValue: item.phoneCode,
                error: false,
              },
              () => {
                document.addEventListener('mousedown', this.handleClickOutside);
              },
            );
          }}
          onMouseEnter={() => this.setState({ selectIndex: index })}
          title={`${item?.name?.en}`}
        >
          <img
            src={`${fileHandlerUrl}/icons/flags/${item?.flag || 'no_flag.png'}`}
            width={25}
            alt={`${item?.name?.en || 'flage airport'}`}
          />
          <div className="w-100 px-3">
            <span>
              {item.name.en.slice(0, 32)}
              <span className={`${item?.name?.en?.length < 32 && 'd-none'}`}>
                ...
              </span>
            </span>
          </div>
          <span className="">+{item.phoneCode}</span>
        </div>
      );
    });
  };

  handleArowKeys = (event, prevent) => {
    let { selectIndex, list } = this.state;
    let { key, keyCode, view } = event;
    //disable arrow key for up and down mainscroll
    if (
      event.key == 'ArrowUp' ||
      event.key == 'ArrowDown' ||
      event.key === 'Enter'
    )
      prevent && view.event.preventDefault();
    if (
      (key == 'ArrowDown' || keyCode == 40) &&
      selectIndex < list.length - 1
    ) {
      this.setState({
        selectIndex: selectIndex + 1,
      });

      scrollBar.current.scrollTop = Math.round(selectIndex * 50 + 50);
    } else if ((key == 'ArrowUp' || keyCode == 38) && selectIndex > 0) {
      this.setState({
        selectIndex: selectIndex - 1,
      });
      scrollBar.current.scrollTop = Math.round(selectIndex * 50 - 50);
    } else if (key == 'Enter' || keyCode == 13) {
      this.setState({
        currentCountry: list[selectIndex],
        inputValue: list[selectIndex].phoneCode,
        isOpen: false,
      });
    }
  };
  // handle user delete key if value is max for time we hav telephoneNumber from props
  handleMaxValue = (event) => {
    const { keyCode } = event;
    const { inputValue, maxlength } = this.state;
    if (
      (keyCode == 8 || keyCode == 46) &&
      inputValue.replaceAll(' ', '').length > maxlength
    ) {
      this.setState({
        inputValue: inputValue.substring(0, inputValue.length - 1),
      });
    }
  };
  render() {
    let {
        error,
        isOpen,
        inputValue,
        searchValue,
        currentCountry,
        list,
        selectIndex,
      } = this.state,
      { containerClass, countryClass, inputClass, tabIndex, name, id } =
        this.props;
    return (
      <div
        id={id}
        name={name}
        className="telephone-input position-relative w-100"
        dir="ltr"
        ref={outSideClick}
        onMouseLeave={() => (scrollBar.current.scrollTop = selectIndex * 50)}
      >
        <div
          className={`border-color border telephone-input-height ${
            error ? 'border-danger' : 'border'
          } d-flex align-items-center ${
            isOpen
              ? 'default-border-top-radius-small'
              : 'default-border-radius-small'
          } ${containerClass}`}
        >
          <div
            className={`border-right border-2   ${
              error ? 'border-danger' : 'border-color'
            } cursor-pointer ${countryClass}`}
            onClick={() =>
              this.setState({ isOpen: !this.state.isOpen }, () => {
                document.addEventListener('mousedown', this.handleClickOutside);
              })
            }
            onKeyDown={(e) => this.handleArowKeys(e, true)}
            tabIndex={tabIndex.toString()}
          >
            <img
              src={`${fileHandlerUrl}/icons/flags/${
                error ? 'no_flag.png' : currentCountry?.flag || 'no_flag.png'
              }`}
              alt={currentCountry?.name?.en || 'airport '}
              width={40}
              height={20}
            />
          </div>
          {/* {!inputValue.includes("+") &&  */}
          <span className="pl-2 pt-1">+</span>
          <div className="d-flex flex-row justfy-content-start align-items-center col-5 px-0">
            <input
              className={`border-0 font-xl-small font-sm-smaller font-small bg-transparent zIndex-3 pl-2 ${inputClass}`}
              value={inputValue}
              onChange={({ target }) => this.inputOnChange(target.value)}
              onKeyDown={(e) => TelephoneInput && this.handleMaxValue(e)}
            />
            <input
              className=" w-100 h-100 border-0 bg-transparent pt-1"
              value={this.inputFormat}
              disabled={true}
            />
          </div>
          <div className="d-flex" style={{ flex: 'fit-content' }}></div>
          <div
            className={`${
              inputValue.length === 0 && 'invisible'
            } mx-3 svg-third cursor-pointer`}
            onClick={() => {
              this.setState({ inputValue: '', isOpen: false });
              this.props.onChange({
                code: '',
                country: '',
                number: '',
                fullNumber: '',
              });
            }}
          >
            <CloseIcon
              size={16}
              color="#aaacaf"
              variant="svg-small svg-sm-normal"
            />
          </div>
        </div>
        {/* Option List design */}
        <div
          className={`bg-white pb-2 w-100 position-absolute border default-border-bottom-radius-small
          ${!isOpen && 'd-none'} `}
          style={{ zIndex: 100 }}
        >
          <div className="px-2 mb-2">
            <div
              className="d-flex align-items-center justify-content-start border-bottom border-color"
              onKeyDown={(e) => {
                this.handleArowKeys(e, true);
              }}
            >
              <div className="mx-2">
                <SearchIcon
                  size={15}
                  color="#6c757d"
                  variant="svg-small svg-sm-normal"
                />
              </div>
              <input
                className="w-100 border-0 default-border-radius-xsmall my-2 pt-1 "
                placeholder="Country or Code"
                onChange={({ target }) => {
                  this.searchCountry(target);
                }}
                value={searchValue}
                tabIndex={tabIndex.toString()}
              />
              <div
                className={`${
                  searchValue.length == 0 && 'invisible'
                } mx-1 svg-third cursor-pointer`}
                onClick={() => {
                  this.setState({ searchValue: '', list: countryList });
                }}
              >
                <CloseIcon
                  size={16}
                  color="#aaacaf"
                  variant="svg-small svg-sm-normal"
                />
              </div>
            </div>
          </div>
          <div
            className="scrollBar pl-2 "
            ref={scrollBar}
            onScroll={({ target }) => {
              this.setState({ selectIndex: Math.ceil(target.scrollTop / 50) });
            }}
          >
            {this.renderList(list, selectIndex)}
          </div>
        </div>
      </div>
    );
  }
}

TelephoneInput.propTypes = {
  containerClass: PropTypes.string,
  inputClass: PropTypes.string,
  countryClass: PropTypes.string,
  tabIndex: PropTypes.string,
  activeCountry: PropTypes.number,
  onChange: PropTypes.func,
  id: PropTypes.string,
  name: PropTypes.string,
  countryAbr: PropTypes.string,
};
TelephoneInput.defaultProps = {
  containerClass: 'py-sm-2 py-1 bg-third-light',
  inputClass: ' pr-2 pt-1',
  countryClass: 'py-2 px-2 px-md-3',
  tabIndex: '4',
  id: 'telephone-input',
  name: 'telephone-input',
  countryAbr: 'ir',
};
export default TelephoneInput;
/**useAge
<TelephoneInput tabIndex={some number}
 containerClass="bg-red",
  inputClass="some calss for input",
  countryClass="come class for flag of counrty",
  activeCountry="98",
  telephoneNumber="+989171111111",
  onChange=function(()=> to get input value ),
  countryAbr = "ir"
  />
 */
